import { addMinutes, isAfter } from 'date-fns';

import { RequestStatusWithDetails, Status } from '../types/RequestStatusWithDetails';

export const stateNeedsUpdating = <T>(state?: RequestStatusWithDetails<T>, minutesSinceLastUpdate = 10) => {
    if (state) {
        return checkStateNeedsUpdating(state.status, state.loadedTimestamp, minutesSinceLastUpdate);
    }
    return true;
};

export const checkStateNeedsUpdating = (status: Status, loadedTimestamp?: number, minutesSinceLastUpdate = 10) => {
    if (
        status === 'pending' ||
        status === 'reloading' ||
        (status === 'success' &&
            loadedTimestamp &&
            isAfter(new Date(loadedTimestamp), addMinutes(new Date(), -1 * minutesSinceLastUpdate)))
    ) {
        return false;
    }
    return true;
};
